// removed by extract-text-webpack-plugin
module.exports = {"dsd-section":"utYhgviA","dsdSection":"utYhgviA","learn-more":"_2GBBXNxY","learnMore":"_2GBBXNxY","button":"_2IzNARIf","content1":"BLjL_i6A","title":"_3_Txj19E","short":"_1ijYgLoZ","long":"_30FlqnGu","content2":"_2p5aEO6m","image-wrap":"_2FGgN-3o","imageWrap":"_2FGgN-3o","img":"_3WO3jSpH","icon":"_28WX2M96"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DsdSection/DsdSection.pcss
// module id = 388
// module chunks = 0